/* eslint-disable no-unused-vars */
import { dsColors } from '@Backlot-Cars/archie';
import BlcMeta from 'components/BlcMeta';
import urlProvider from 'contexts/urls/urlsProvider';
import { BlcLayoutGlobalStyle } from 'partials/BlcLayout/styles';
import PropTypes from 'prop-types';

const BlcLayoutBase = ({
	id = null,
	children = null,
	className = null,
	loaderColor = dsColors.colorSurface.secondary,
	robotsMeta = false,
	fullHeight,
	...layoutProps
}) => {
	const classNames = [className];
	if (fullHeight) classNames.push('full-height-layout');
	return (
		<>
			<div id={id} className={classNames.join(' ')}>
				<BlcMeta robotsMeta={robotsMeta} />
				{children}
			</div>
			<BlcLayoutGlobalStyle loaderColor={loaderColor} fullHeight={fullHeight} {...layoutProps} />
		</>
	);
};

BlcLayoutBase.propTypes = {
	/**
	 * Set the Layout children
	 */
	children: PropTypes.node,
	/**
	 * Set the loading bar color
	 */
	loaderColor: PropTypes.string,
	/**
	 * Set the body background color
	 */
	background: PropTypes.string,
	/**
	 * Set the layout global ID
	 */
	id: PropTypes.string,
	/**
	 * Set the layout container class name
	 */
	className: PropTypes.string,
	/**
	 * Various urls to be used on pages like sign up and sign in urls
	 */
	urls: PropTypes.shape({ signUpUrl: PropTypes.string, signInUrl: PropTypes.string }),
	/**
	 * Add a robots meta tag
	 */
	robotsMeta: PropTypes.bool,
};

export default urlProvider(BlcLayoutBase);
